import { render } from "./wxShareUserCard.vue?vue&type=template&id=2c41309a&scoped=true"
import script from "./wxShareUserCard.vue?vue&type=script&lang=js"
export * from "./wxShareUserCard.vue?vue&type=script&lang=js"

import "./wxShareUserCard.vue?vue&type=style&index=0&id=2c41309a&lang=scss"
import "./wxShareUserCard.vue?vue&type=style&index=1&id=2c41309a&lang=scss&scoped=true"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c41309a"]])

export default __exports__